<template>
  <div class="height-limiter" :style="containerStyle">
    <div ref="content" v-no-capture>
      <slot></slot>
    </div>
    <div
      class="placeholder-container"
      :class="bgType"
      @click="expanded = true"
      v-if="!expanded && contentHeight > maxHeight"
    >
      <span class="placeholder pointer">
        {{ label }}
      </span>
    </div>
  </div>
</template>

<script>
/**
 * This component wraps the passed <slot> inside a container of fixed max-height (prop - maxHeight). If there is more content to be shown, it given an option to show full content
 */
export default {
  name: 'HeightLimiter',
  props: {
    maxHeight: { type: [Number, String], default: 205 },
    bgType: { type: String, default: 'default' }, // tells the background type for content region. Can be default | primary | secondary
    label: { type: String, default: 'Show all' }
  },
  data() {
    return {
      expanded: false,
      contentHeight: false
    }
  },
  computed: {
    containerStyle() {
      return this.expanded ? {} : { maxHeight: `${this.maxHeight}px` }
    }
  },
  methods: {
    updateContentHeight() {
      const { height } = this.$refs.content?.getBoundingClientRect() || {}
      this.contentHeight = height
    }
  },
  mounted() {
    setTimeout(this.updateContentHeight, 0)
  },
  updated() {
    setTimeout(this.updateContentHeight, 0)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.height-limiter {
  overflow: hidden;
  position: relative;
}
.placeholder-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(to top, $documentColor 10px, rgba(255, 255, 255, 0) 50px);
  &.primary {
    background: linear-gradient(to top, $contentBGPrimary 10px, rgba(255, 255, 255, 0) 50px);
  }
  &.secondary {
    background: linear-gradient(to top, $contentBGSecondary 10px, rgba(255, 255, 255, 0) 50px);
  }
}
.placeholder {
  padding: 0 10px;
  background: $documentColor;
  border-radius: 20px;
  color: $secondary;
  text-decoration: underline;
  white-space: nowrap;
  &:hover {
    color: $prime;
  }
}

.placeholder-container.primary .placeholder {
  background-color: $contentBGPrimary;
}
.placeholder-container.secondary .placeholder {
  background-color: $contentBGSecondary;
}

.height-limiter:hover .placeholder-container {
  background: linear-gradient(to top, $documentColor 10px, rgba(255, 255, 255, 0) 30px);
  &.primary {
    background: linear-gradient(to top, $contentBGPrimary 10px, rgba(255, 255, 255, 0) 30px);
  }
  &.secondary {
    background: linear-gradient(to top, $contentBGSecondary 10px, rgba(255, 255, 255, 0) 30px);
  }
}
</style>
